import { createContractRequest } from './helper';
export const getAgentOffers = createContractRequest({
    route: '/contract/offers/agents/:agentId',
    method: 'get',
    source: 'data',
    recoverableErrors: [404, 400],
    onRecoverableError: (error) => {
        if (error.response?.status === 404 || error.response?.status === 400) {
            return [];
        }
        return 'unrecoverable';
    },
});
